"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.overrideBootstrapCssVariables = void 0;
const CalculateCssVariableValue_1 = __importDefault(require("./CalculateCssVariableValue"));
const ScanDocumentForCssVariableNames_1 = __importDefault(require("./ScanDocumentForCssVariableNames"));
/** @description Scans document for css variables, calculates new values for those dependent on bootstrap base variables,
 * adds html style element to document.head to override previous css variables with new values.
 *
 * @param {BootstrapVariableValues} bootstrapVariableValues
 */
function overrideBootstrapCssVariables(bootstrapVariableValues) {
    // If document contains css variables, retrieve names and calculate new values from bootstrapVariableValues
    let cssVariableNames = (0, ScanDocumentForCssVariableNames_1.default)();
    let cssVariablesRuleDefinition = _getCssVariablesRuleDefinition(cssVariableNames, bootstrapVariableValues);
    if (!cssVariablesRuleDefinition ||
        !cssVariablesRuleDefinition.properties ||
        cssVariablesRuleDefinition.properties.length === 0)
        return;
    // Add cssVariables to document.head as style element.
    let cssVariablesStyleElement = document.createElement('style');
    document.head.appendChild(cssVariablesStyleElement);
    cssVariablesStyleElement.setAttribute('dynamic-style-sheet', '');
    cssVariablesStyleElement.type = 'text/css';
    cssVariablesStyleElement.appendChild(document.createTextNode(_cssRuleDefinitionToText(cssVariablesRuleDefinition)));
    return cssVariablesStyleElement;
}
exports.overrideBootstrapCssVariables = overrideBootstrapCssVariables;
function _getCssVariablesRuleDefinition(cssVariableNames, bootstrapVariableValues) {
    return {
        selector: ':root',
        properties: cssVariableNames
            .map(function (cssVariableName) {
            return {
                property: cssVariableName,
                value: (0, CalculateCssVariableValue_1.default)(cssVariableName, bootstrapVariableValues),
            };
        })
            .filter((cssRuleProperty) => cssRuleProperty.property && cssRuleProperty.value),
    };
}
function _cssRuleDefinitionToText(cssRuleDefinition) {
    let cssText = `${cssRuleDefinition.selector} {\n`;
    cssRuleDefinition.properties.forEach(function (cssRuleProperty) {
        if (cssRuleProperty.property && cssRuleProperty.value) {
            cssText += `${cssRuleProperty.property}: ${cssRuleProperty.value};\n`;
        }
    });
    cssText += '}';
    return cssText;
}
//# sourceMappingURL=OverrideBootstrapCssVariables.js.map